module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.1999/img/callout-blobs.svg"